/**
 * @generated SignedSource<<6fad7c8e1b8a51481eaec9677e0b3875>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedYMALItemsCarousel_viewer$data = {
  readonly ymalItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_items">;
      } | null;
    } | null> | null;
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_viewer">;
  readonly " $fragmentType": "PdpSharedYMALItemsCarousel_viewer";
};
export type PdpSharedYMALItemsCarousel_viewer$key = {
  readonly " $data"?: PdpSharedYMALItemsCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedYMALItemsCarousel_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "ymalItems"
],
v1 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 6,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./PdpSharedYMALItemsCarouselPaginationQuery.graphql')
    }
  },
  "name": "PdpSharedYMALItemsCarousel_viewer",
  "selections": [
    {
      "alias": "ymalItems",
      "args": null,
      "concreteType": "moreLikeThisItemConnection",
      "kind": "LinkedField",
      "name": "__PdpSharedYMALItemsCarousel_ymalItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "moreLikeThisItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "isTrade",
                      "variableName": "isTrade"
                    },
                    {
                      "kind": "Variable",
                      "name": "priceBookName",
                      "variableName": "priceBookName"
                    },
                    (v1/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "PdpSharedProductTileCarousel_items"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        (v1/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "22b7ef35e12885f8553e96645a352e6a";

export default node;
